import React from "react"
import styled from "@emotion/styled"
import InformationImage from "./images/information-image"
import facepaint from "facepaint"
const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const Container = styled.div`
  text-align: left;
  color: #ffffff;
  margin: 0 auto;
  display: flex;
  width: 100%;
  max-width: 1000px;
  ${mq({
    padding: ["15.0vh 8.0vw", "0 70px 180px", "0 70px 180px", "0 70px 180px"],
    flexDirection: ["column", "row", "row", "row"],
  })}
`
const TextContainer = styled.div`
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${mq({
    width: ["100.0%", "58.0%", "58.0%", "58.0%"],
    paddingLeft: ["0", "8.0%", "8.0%", "8.0%"],
  })}
`

const InformationContainer = styled.div`
  ${mq({
    marginBottom: ["6.0vw", "0", "0", "0"],
    width: ["100%", "42%", "42%", "42%"],
  })}
`
const InformationLink = styled.a``

const Title = styled.h2`
  line-height: 1.45;
  ${mq({
    marginBottom: ["6.0vw", "25px", "25px", "25px"],
    fontSize: ["5.0vw", "1.75rem", "1.75rem", "1.75rem"],
    textAlign: ["left", "center", "center", "center"],
  })}
`
const InfoText = styled.p`
  line-height: 1.85;
  text-align: justify;
  text-justify: inter-ideograph;
  ${mq({
    marginBottom: ["3.6vw", "35px", "35px", "35px"],
    fontSize: ["3.5vw", "0.875rem", "0.875rem", "0.875rem"],
  })}
`
const InfoTextCredit = styled.p`
  line-height: 1.85;
  ${mq({
    marginBottom: ["10.0vw", "35px", "35px", "35px"],
    fontSize: ["2.85vw", "0.625rem", "0.625rem", "0.625rem"],
    textAlign: ["left", "center", "center", "center"],
  })}
`
const InfoButtonArea = styled.p`
  text-align: center;
  ${mq({
    marginTop: ["0", "18px", "18px", "18px"],
  })}
`
const InfoButton = styled.a`
  position: relative;
  margin: 0 auto;
  background-color: #c7a542;
  font-weight: bold;
  text-decoration: none;
  color: #ffffff;
  line-height: 1.2;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;

  ::after {
    position: relative;
    content: "▶";
    padding: 0;
    line-height: 1;
    ${mq({
      top: ["-0.4vw", "-0.05rem", "-0.05rem", "-0.05rem"],
      fontSize: ["4.2vw", "0.625rem", "0.625rem", "0.625rem"],
      paddingLeft: ["1.6vw", "0.25rem", "0.25rem", "0.25rem"],
    })}
  }
  :hover {
    background-color: #ffffff;
    color: #c7a542;
  }
  ${mq({
    display: ["block", "inline-block", "inline-block", "inline-block"],
    fontSize: ["5.8vw", "0.875rem", "0.875rem", "0.875rem"],
    padding: ["3.5vw 0", "12px 24px", "12px 24px", "12px 24px"],
    borderRadius: ["2.0vw", "3.2px", "3.2px", "3.2px"],
  })}
`

const InformationBlock = () => (
  <Container>
    <InformationContainer>
      <InformationLink
        href="https://www.wwdjapan.com/articles/998392"
        target="_blank"
      >
        <InformationImage></InformationImage>
      </InformationLink>
    </InformationContainer>

    <TextContainer>
      <Title>
        ファッション界の未来を担う
        <br />
        「ネクストリーダー」10組
      </Title>
      <InfoText>
        ファッション界の次世代を担う人に光を当てた特集「ネクストリーダー」は今年で3回目を迎えました。対象は、デザイナー、バイヤー、スタイリスト、インフルエンサー、経営者、デジタルなど、ファッションビジネスに関わるあらゆる分野の若きリーダーたちです。情熱と才能を持ち、強い信念で前へ進む10組のネクストリーダーを紹介します。
      </InfoText>
      <InfoTextCredit>
        MODEL：MIKA (IMAGE)
        <br />
        PHOTO：KINYA OTA (MILD)
        <br />
        STYLING：CHIE ATSUMI
        <br />
        HAIR：KOICHI NISHIMURA (ANGLE)
        <br />
        MAKEUP：YUKA WASHIZU (BEAUTY DIRECTION)
      </InfoTextCredit>
      <InfoButtonArea>
        <InfoButton
          href="https://www.wwdjapan.com/articles/998392"
          target="_blank"
        >
          2020年1月6日号を購入
        </InfoButton>
      </InfoButtonArea>
    </TextContainer>
  </Container>
)

export default InformationBlock
